// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3fe4336c","703":"6f79e622","787":"ce07382d"}[chunkId] + ".chunk.js";
};